import React from 'react';
import { FaCheck, FaSignOutAlt, FaTimesCircle } from 'react-icons/fa';
import U2000ActionBtn from '../buttons/U2000ActionBtn';
import U2000BasicDialog from './U2000BasicDialog';

export interface U2000UnsavedNodePositionsDialogLabels {
  title: string;
  message: string;
  saveAndExit: string;
  discard: string;
  cancel: string;
}

interface U2000UnsavedNodePositionsDialogProps {
  isOpen: boolean;
  labels: U2000UnsavedNodePositionsDialogLabels;
  showSaveAction: boolean;
  isSaving?: boolean;
  onSaveAndExit: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

/** Confirmation fermeture graphe React Flow avec positions non persistées (BL-0705). */
const U2000UnsavedNodePositionsDialog: React.FC<U2000UnsavedNodePositionsDialogProps> = ({
  isOpen,
  labels,
  showSaveAction,
  isSaving = false,
  onSaveAndExit,
  onDiscard,
  onCancel,
}) => {
  return (
    <U2000BasicDialog
      isOpen={isOpen}
      onClose={() => onCancel()}
      title={labels.title}
      width="max-w-lg"
      overlayClassName="z-[1100]"
    >
      <div className="flex flex-col items-center justify-center p-4 text-center">
        <p className="text-sm leading-relaxed text-gray-700">{labels.message}</p>
      </div>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2 gap-y-2 border-t-2 border-gray-300 p-4">
        {showSaveAction ? (
          <U2000ActionBtn
            label={labels.saveAndExit}
            icon={FaCheck}
            handleClick={onSaveAndExit}
            disabled={isSaving}
          />
        ) : null}
        <U2000ActionBtn
          label={labels.discard}
          icon={FaSignOutAlt}
          handleClick={onDiscard}
          disabled={isSaving}
          variant="secondary"
        />
        <U2000ActionBtn
          label={labels.cancel}
          icon={FaTimesCircle}
          handleClick={onCancel}
          disabled={isSaving}
          variant="secondary"
        />
      </div>
    </U2000BasicDialog>
  );
};

export default U2000UnsavedNodePositionsDialog;
